<template lang="pug">
v-container.pa-4
  h2.my-2 Subir evento manualmente
  ImportDotAll()
  div.my-2
    h2.my-2 Eventos
    list(url='/event/search_event' title='Eventos' attribute='events' listBy='name')
</template>

<script>
// import utils from '../utils/requests'
import List from '../components/List'
import ImportDotAll from '../components/Events/ImportDotAll'

export default {
  components: {
    List,
    ImportDotAll
  }
}
</script>
